export default __webpack_public_path__ + "static/media/Manish.bc5c7b1f.png";